// extracted by mini-css-extract-plugin
export default {"EditorContent":"FrontCreateEvent_EditorContent__8MQLZ"};